import { TCoordinate } from '../../../packages/api-models/common/json_query';
import { equals } from 'ramda';

export const coordsIsEqual = (coords1: TCoordinate[], coords2: TCoordinate[]) =>
  equals(coords1.concat().sort(), coords2.concat().sort());
